import { useEffect, useMemo, useState } from 'react';
import ButtonWithIcon from 'src/SharedComponents/ButtonWithIcon/ButtonWithIcon';
import CreatePartner from './CreatePartner/CreatePartner';
import PartnersInfo from './PartnersInfo/PartnersInfo';
import { useGetAuraSupportInfoWrapper } from 'src/Utils/Hooks/useGetAdminInfo/useGetAuraSupportInfoWrapper';
import { useAuraSupportInfo } from 'src/Utils/Hooks/UseAuraInfoContext';
import { IPartner } from 'src/Utils/Hooks/useGetAdminInfo/useGetAuraSupportInfo';
import OpenPartner from './OpenPartner/OperPartner';
import SearchBar from 'src/SharedComponents/SearchBar/SearchBar';
import { useSearch } from 'src/Utils/Hooks/SearchData/useSearch';
import { useSupportPermissions } from 'src/Utils/Hooks/useGetAdminInfo/useSupportPermissions';

const Partners: React.FC = () => {
    const { getAuraSupportInfo } = useGetAuraSupportInfoWrapper();
    const { adminDetails } = useAuraSupportInfo();
    const { isSupportAdmin } = useSupportPermissions();
    const [showCreatePartnerDialog, setShowCreatePartnerDialog] = useState<boolean>(false);
    const [showPartnerInfo, setShowPartnerInfo] = useState<boolean>(false);
    const [selectedPartner, setSelectedPartner] = useState<IPartner>();
    const [searchText, setSearchText] = useState<string>('');
    const searchKeys = useMemo<(keyof IPartner)[]>(() => ['name'], []);
    const filteredPartnerInfo = useSearch(adminDetails?.partners, searchText, searchKeys);
    useEffect(() => {
        if(adminDetails && selectedPartner){
            let distributorId = selectedPartner.distributorId;
            setSelectedPartner(adminDetails.partners.find(partner => partner.distributorId === distributorId));
        }
    }, [adminDetails, selectedPartner, setSelectedPartner])

    const openUpdatePartner = (partner: IPartner, show: boolean) => {
        setShowPartnerInfo(show);
        setSelectedPartner(partner);
    }

    return (
        <>
        {
            showPartnerInfo ? (selectedPartner && 
                <OpenPartner partner={selectedPartner} onClose={() => { setShowPartnerInfo(false); getAuraSupportInfo() }} />
            ) : (
            <div>

                <div className="row" style={{padding:'0px 37px 0px 37px'}}>
                    <div className="col d-flex align-items-center" style={{maxWidth: '92%'}}>
                        <SearchBar onChange={(text: string) => { setSearchText(text); }} />
                    </div>
                    <div className="col-auto d-flex justify-content-end">
                         <ButtonWithIcon
                            backgroundColor='var(--primary-gradient)'
                            onClick={() => { setShowCreatePartnerDialog(true) }}
                            label='New Partner'
                            icon='bi bi-plus-lg'
                            testId='newUser'
                            color='white'
                            disable={!isSupportAdmin}
                    />
                    </div>
              </div>

                <div className="col-auto d-flex justify-content-end">
                   
                </div>
                {showCreatePartnerDialog &&
                    <CreatePartner
                        onClose={() => setShowCreatePartnerDialog(false)}
                        updatePartners={() => { getAuraSupportInfo() }} />
                }
                {adminDetails &&
                    <div className='row'>
                        <div className='mt-5'>
                            <PartnersInfo
                                partnerInfo={filteredPartnerInfo}
                                openUpdatePartner={openUpdatePartner}
                            />
                        </div>
                    </div>
                }
            </div>)
        }</>
    )
}
export default Partners;